// polyfill for Element.closest for IE
// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
export function polyfillElementClosest() {
    var ElementPrototype = Element.prototype;
    if (!ElementPrototype.matches) {
        ElementPrototype.matches =
            ElementPrototype.msMatchesSelector ||
                ElementPrototype.webkitMatchesSelector;
    }
    if (!ElementPrototype.closest) {
        ElementPrototype.closest = function (s) {
            var el = this;
            do {
                if (ElementPrototype.matches.call(el, s))
                    return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }
}
// polyfill for CustomEvent constructor in IE
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
// we can't apply it in IIFE unconditionally because of angular bugged tree-shaking
export function polyfillCustomEvent() {
    if (typeof window.CustomEvent === "function")
        return false;
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    window.CustomEvent = CustomEvent;
}
;
